import script from "./DPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./DPagination.vue?vue&type=script&setup=true&lang=js"

import "./DPagination.vue?vue&type=style&index=0&id=8b70f170&lang=scss"

const __exports__ = script;

export default __exports__